module.exports = __webpack_public_path__ + "img/69.0b2e520a.png";